import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { OrderComplete as RedesignOrderComplete } from '../../../pages';
import { basketActions as basketThunkActions } from '../../actions';
import { basketActions, basketSelectors, paymentActions } from '../../redux';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyOrderView } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignOrderComplete,
  LegacyOrderView,
);

export type StateProps = ReturnType<typeof mapStateToProps>;

export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (s: Store.State) => {
  const orderInformation = s.basket.basketSnapshot;

  return {
    basketSnapshot: orderInformation,
    cancelTimeout: basketSelectors.getSubmittedOrderCancelTimeout(s),
    Languages: s.locale.languages,
    Restaurant: s.collectionRestaurants,
    translate: getTranslate(s.locale),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => ({
  cancelCheckoutFlow: () => {
    dispatch(basketActions.cancelCheckoutFlow());
  },
  continueCheckoutFlow: () => {
    dispatch(basketActions.continueCheckoutFlow());
  },
  ClearBasket: (payload: basketThunkActions.ClearBasketProps) => {
    dispatch(basketThunkActions.clearBasket(payload));
  },
  setDefaultPayment: (payload: { paymentId: string }) => {
    dispatch(paymentActions.setDefaultSelected(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
